import React from "react";
import { FaUsers, FaShoppingCart } from "react-icons/fa";

const TabBar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="mb-8">
      <div className="flex gap-2 border-b-2 border-main-border">
        <button
          onClick={() => setActiveTab("users")}
          className={`flex items-center gap-2 px-6 py-4 font-bold text-lg transition-all duration-200 ${activeTab === "users"
              ? "text-main-blue border-b-4 border-main-blue -mb-0.5"
              : "text-main-subfont hover:text-main-font"
            }`}
        >
          <FaUsers className="text-xl" />
          Users
        </button>
        <button
          onClick={() => setActiveTab("purchases")}
          className={`flex items-center gap-2 px-6 py-4 font-bold text-lg transition-all duration-200 ${activeTab === "purchases"
              ? "text-main-blue border-b-4 border-main-blue -mb-0.5"
              : "text-main-subfont hover:text-main-font"
            }`}
        >
          <FaShoppingCart className="text-xl" />
          Purchases
        </button>
      </div>
    </div>
  );
};

export default TabBar;


